import styled from 'styled-components'
import { NoPaddingCol } from 'Components/EnhacedFlexboxGrid'
import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'
import { GREY_BACKGROUND } from '@CSSVars/colors'

export const _MainContentCol = styled(NoPaddingCol)`
  background: ${GREY_BACKGROUND};
  flex: 1;
  padding: 24px 72px 0 72px;

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    padding: 24px 40px 0 40px !important;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    padding: 12px 20px 0 20px !important;
    width: 100%;
  }
`
